/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CancelStripeSubscriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CancelStripeSubscriptionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CancelStripeSubscriptionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CancelStripeSubscriptionSecurity$outboundSchema: z.ZodMiniType<
  CancelStripeSubscriptionSecurity$Outbound,
  CancelStripeSubscriptionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function cancelStripeSubscriptionSecurityToJSON(
  cancelStripeSubscriptionSecurity: CancelStripeSubscriptionSecurity,
): string {
  return JSON.stringify(
    CancelStripeSubscriptionSecurity$outboundSchema.parse(
      cancelStripeSubscriptionSecurity,
    ),
  );
}

/** @internal */
export type CancelStripeSubscriptionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CancelStripeSubscriptionRequest$outboundSchema: z.ZodMiniType<
  CancelStripeSubscriptionRequest$Outbound,
  CancelStripeSubscriptionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function cancelStripeSubscriptionRequestToJSON(
  cancelStripeSubscriptionRequest: CancelStripeSubscriptionRequest,
): string {
  return JSON.stringify(
    CancelStripeSubscriptionRequest$outboundSchema.parse(
      cancelStripeSubscriptionRequest,
    ),
  );
}
